'use client';

import { PropsWithChildren, useCallback, useEffect } from 'react';

import { useEvent, useInterval } from 'react-use';

import { setSyncConfig, useSyncStore } from '@/lib/sync/store';

import { useConfigValue } from './config-provider';
import { useStorageAccess } from './storage-access-provider';

export function CrossTabSyncProvider({ children }: PropsWithChildren) {
  const { hasStorageAccess } = useStorageAccess();
  const syncTimeout = useConfigValue<number>('meta.crossTabSyncTimeout');
  const isSyncDisabled = !hasStorageAccess || !syncTimeout || syncTimeout === 0;

  useEffect(() => {
    setSyncConfig({ syncTimeout: syncTimeout || 0 });
  }, [syncTimeout]);

  const updateHeartbeat = useCallback(() => {
    if (typeof document !== 'undefined' && !document.hidden && hasStorageAccess) {
      useSyncStore.getState().setHeartbeatTimestamp(Date.now());
    }
  }, [hasStorageAccess]);

  useInterval(updateHeartbeat, isSyncDisabled ? null : 5000);
  useEvent(
    'visibilitychange',
    updateHeartbeat,
    typeof document !== 'undefined' ? document : undefined,
  );
  useEvent('beforeunload', updateHeartbeat, typeof window !== 'undefined' ? window : undefined);

  useEffect(() => {
    if (isSyncDisabled) return;
    updateHeartbeat();
  }, [isSyncDisabled, updateHeartbeat]);

  return <>{children}</>;
}
